import React, { useEffect, useState } from 'react';
import FilterDropdown from './Filter/components/FilterDropdown';
import { translate } from '../services/translate';
import { polygonService } from '../services/central-api/polygons';
import { DropDownDirectionType } from 'react-native-dropdown-picker';
import { StyleProp, TextStyle } from 'react-native';
import { useCurrentApp } from '../context/CurrentApp';

interface Props {
    polygonType: string;
    setPolygonType: React.Dispatch<React.SetStateAction<string>>;
    dropDownDirection?: DropDownDirectionType;
    zIndex: number;
    label?: string;
    showTooltip?: boolean;
    tooltipText?: string;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    companyId?: number;
    requiresCompanyId?: boolean;
    setMapPolygonsIds?: React.Dispatch<React.SetStateAction<number[]>>;
}

export default function PolygonTypeDropdown({
    polygonType,
    setPolygonType,
    dropDownDirection,
    zIndex,
    label,
    showTooltip,
    tooltipText,
    labelStyle,
    viewStyle,
    companyId,
    requiresCompanyId,
    setMapPolygonsIds
}: Props) {
    const { isParentApp } = useCurrentApp();
    const [polygonsType, setPolygonsType] = useState<{ type: string; }[]>([]);

    async function getPolygonsType() {
        try {
            const polygonsType = await polygonService.getPolygonsType(isParentApp && companyId && requiresCompanyId ? companyId : undefined);
            setPolygonsType(polygonsType);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (requiresCompanyId && isParentApp && !companyId) {
            return;
        }

        getPolygonsType();
    }, [isParentApp, companyId]);

    return (
        <FilterDropdown
            label={label}
            items={[
                ...polygonsType.map((polygon) => {
                    return {
                        label: polygon.type,
                        value: polygon.type
                    };
                })
            ]}
            multiple={false}
            zIndex={zIndex}
            value={polygonType}
            setValue={(value) => {
                setMapPolygonsIds?.([]);
                setPolygonType(value);
            }}
            dropDownDirection={dropDownDirection ?? 'TOP'}
            placeholder={translate('map')}
            tooltipText={tooltipText}
            showTooltip={showTooltip}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
